import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledList = styled.ul`
  list-style-type: unset;
`;

const SubList = styled.ul`
  list-style-type: circle;
  padding-left: 1.5rem;
`;

const Box = styled.div`
  border: 3px solid #ff8f4e;
  border-radius: 10px;
`;

const ReadMoreLink = styled.a`
  color: blue;
  cursor: pointer;
`;

const IndiaAIFestivalSubmissionGuidelines = () => {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState({
    creators: false,
    shapers: false,
    nurturers: false,
  });

  return (
    <>
      <h2 className="mb-0 text-center">
        {t("impact_festival_2025.what_to_submit")}
      </h2>
      <div className="mt-md-2 row">
        <div className="col-md-4 mt-3">
          <Box className="h-100 w-100 rounded-10 py-4 px-3 d-flex align-items-top justify-content-center">
            <div>
              <h5 className="text-blue text-center">
                {t("impact_festival_2025.impact_creators")}
              </h5>
              <StyledList>
                <li className="lead">
                  {t("impact_festival_2025.impact_creators_description_1")}
                </li>
                <SubList>
                  <li className="lead">
                    {t(
                      "impact_festival_2025.impact_creators_description_1_sub_item_1"
                    )}
                  </li>
                  <li className="lead">
                    {t(
                      "impact_festival_2025.impact_creators_description_1_sub_item_2"
                    )}
                  </li>
                  <li className="lead">
                    {t(
                      "impact_festival_2025.impact_creators_description_1_sub_item_3"
                    )}
                  </li>
                  <li className="lead">
                    {t(
                      "impact_festival_2025.impact_creators_description_1_sub_item_4"
                    )}
                  </li>
                </SubList>
                <li className="lead">
                  {t("impact_festival_2025.impact_creators_description_2")}
                </li>
              </StyledList>
            </div>
          </Box>
        </div>
        <div className="col-md-4 mt-3">
          <Box className="h-100 w-100 rounded-10 py-4 px-3 d-flex align-items-top justify-content-center">
            <div>
              <h5 className="text-blue text-center">
                {t("impact_festival_2025.impact_shapers")}
              </h5>
              <StyledList>
                <li className="lead">
                  {t("impact_festival_2025.impact_shapers_description_1")}
                </li>
                <li className="lead">
                  {t("impact_festival_2025.impact_shapers_description_2")}
                </li>
              </StyledList>
            </div>
          </Box>
        </div>
        <div className="col-md-4 mt-3">
          <Box className="h-100 w-100 rounded-10 py-4 px-3 d-flex align-items-top justify-content-center">
            <div>
              <h5 className="text-blue text-center">
                {t("impact_festival_2025.impact_nurturers")}
              </h5>
              <StyledList>
                <li className="lead">
                  {t("impact_festival_2025.impact_nurturers_description_1")}
                </li>
              </StyledList>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
};

export default IndiaAIFestivalSubmissionGuidelines;
